export const isFile = (item) => item.previewType === 'file';
export const isFolder = (item) => item.previewType === 'folder';
export const isNotUndefined = (item) => item !== undefined;
